<app-dialog-header
  [header]="'library.user_card.dialog.generate_report.header' | translate"
  iconClass="icon-reports-icon"
>
</app-dialog-header>
<app-dialog-content [formGroup]="form">
  <div class="p-grid">
    <div class="p-col-12">
      <app-checkbox
        id="storage"
        [label]="'library.user_card.dialog.generate_report.storage.label' | translate"
        binary="true"
        data-qa="storage"
        formControlName="storage"
      ></app-checkbox>
    </div>
  </div>
  <div class="p-grid">
    <div class="p-col-12">
      <app-checkbox
        id="mobile"
        [label]="'library.user_card.dialog.generate_report.mobile.label' | translate"
        binary="true"
        data-qa="mobile"
        formControlName="mobile"
      ></app-checkbox>
    </div>
  </div>
  <div
    [hidden]="!form.value.mobile"
    class="item-range"
  >
    <app-calendar
      [appApiErrors]="errors? [errors.mobileFrom, errors.mobileTo] : []"
      [maxDate]="maxDate"
      [minDate]="minDate"
      [placeholder]="'date.placeholder' | translate"
      [range]="true"
      dateFormat="yyyy-MM-dd"
      dataType="string"
      formControlName="mobileRange"
    ></app-calendar>
    <app-form-control-error [control]="form.get('mobileRange')"></app-form-control-error>
  </div>
  <div class="p-grid">
    <div class="p-col-12">
      <app-checkbox
        id="network"
        [label]="'library.user_card.dialog.generate_report.network.label' | translate"
        binary="true"
        data-qa="network"
        formControlName="network"
      ></app-checkbox>
    </div>
  </div>
  <div
    [hidden]="!form.value.network"
    class="item-range"
  >
    <app-calendar
      [appApiErrors]="errors? [errors.networkFrom, errors.networkTo] : []"
      [maxDate]="maxDate"
      [minDate]="minDate"
      [placeholder]="'date.placeholder' | translate"
      [range]="true"
      dateFormat="yyyy-MM-dd"
      dataType="string"
      formControlName="networkRange"
    ></app-calendar>
    <app-form-control-error [control]="form.get('networkRange')"></app-form-control-error>
  </div>
  <div class="p-grid">
    <div class="p-col-12">
      <app-checkbox
        id="foreground"
        [label]="'library.user_card.dialog.generate_report.foreground.label' | translate"
        binary="true"
        data-qa="foreground"
        formControlName="foreground"
      ></app-checkbox>
    </div>
  </div>
  <div
    [hidden]="!form.value.foreground"
    class="item-range"
  >
    <app-calendar
      [appApiErrors]="errors? [errors.foregroundFrom, errors.foregroundTo] : []"
      [maxDate]="maxDate"
      [minDate]="minDate"
      [placeholder]="'date.placeholder' | translate"
      [range]="true"
      dateFormat="yyyy-MM-dd"
      dataType="string"
      formControlName="foregroundRange"
    ></app-calendar>
    <app-form-control-error [control]="form.get('foregroundRange')"></app-form-control-error>
  </div>
  <app-form-control-error [control]="form"></app-form-control-error>
</app-dialog-content>
<div class="dialog-footer">
  <button
    (click)="close()"
    data-qa="device-generate-report-dialog-close-button"
    type="button"
    class="proget-button text-only"
  >
    {{ 'button.close.label' | translate }}
  </button>
  <button
    [submitButton]="form"
    (click)="submit()"
    data-qa="device-generate-report-dialog-submit-button"
    type="button"
    class="proget-button text-only primary-button"
  >
    {{ 'button.execute.label' | translate }}
  </button>
</div>
